import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65d72404"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled", "value", "rows", "placeholder"]

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TextArea',
  props: {
    value: {},
    rows: { default: 4 },
    disabled: { type: Boolean, default: false },
    resizable: { type: Boolean, default: false },
    placeholder: { default: '' }
  },
  emits: ["update:value"],
  setup(__props: any, { expose: __expose, emit: __emit }) {



const emit = __emit

const handleInput = (e: Event) => {
  emit('update:value', (e.target as HTMLInputElement).value)
}

const textareaRef = ref<HTMLTextAreaElement>()
const focus = () => {
  if (textareaRef.value) textareaRef.value.focus()
}

__expose({
  focus,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("textarea", {
    class: _normalizeClass(["textarea", {
      'disabled': _ctx.disabled,
      'resizable': _ctx.resizable,
    }]),
    ref_key: "textareaRef",
    ref: textareaRef,
    disabled: _ctx.disabled,
    value: _ctx.value,
    rows: _ctx.rows,
    placeholder: _ctx.placeholder,
    onInput: _cache[0] || (_cache[0] = $event => handleInput($event))
  }, null, 42, _hoisted_1))
}
}

})